// test1064
(1064 && 0);
